import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";

// Enum options extracted from Ruby filter :instrument_type, collection: %w[Strategy]
export const instrumentTypeOptions = [{ value: "Strategy", label: "Strategy" }];

export const filterStrategyChildrenSchema = z.object({
  instrument_type_contains: z.string().nullable().optional(),
  strategy_id_contains: z.number().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterStrategyChildrenSchema = z.infer<
  typeof filterStrategyChildrenSchema
>;

export const fields: Field[] = [
  {
    name: "instrument_type_contains",
    label: "Instrument Type",
    type: "select",
    useTranslation: false,
    options: instrumentTypeOptions,
  },
  {
    name: "strategy_id_contains",
    label: "Strategy ID",
    type: "input",
    input_type: "number",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export const client = "legacy-quantilia";

export function FilterStrategyChildren() {
  return (
    <FilterTable
      client={client}
      schema={filterStrategyChildrenSchema}
      tableName="strategy_children"
      customBuildPath={() => `${client}/strategy_child`}
      fields={fields}
    />
  );
}
